import { api } from './client'

// Participant-facing
export const getGameForLesson = (lessonId) =>
  api.get(`/games/lessons/${lessonId}`).then((r) => r.data)

export const startGameAttempt = (lessonId) =>
  api.post(`/games/lessons/${lessonId}/attempts`).then((r) => r.data)

export const reportStageResult = (attemptId, stageResult) =>
  api.patch(`/games/attempts/${attemptId}/stage`, stageResult).then((r) => r.data)

// Mode penilaian server: kirim keputusan peserta (decision_log); server yang menghitung skor.
// Mode klien (lama): tanpa body, skor sudah dikirim per tahap lewat reportStageResult.
export const submitGameAttempt = (attemptId, decisionLog) =>
  api
    .post(`/games/attempts/${attemptId}/submit`, decisionLog ? { decision_log: decisionLog } : undefined)
    .then((r) => r.data)

export const listGameAttempts = (lessonId) =>
  api.get(`/games/lessons/${lessonId}/attempts`).then((r) => r.data)

// Trainer/admin authoring
export const getGameScenarioAdmin = (lessonId) =>
  api.get(`/games/lessons/${lessonId}/admin`).then((r) => r.data)

// Templat bawaan platform (tersedia di semua paket): build + penilai sudah disediakan.
export const createGameFromTemplate = (lessonId, template) =>
  api.post(`/games/lessons/${lessonId}/from-template`, { template }).then((r) => r.data)

export const upsertGameScenario = (lessonId, payload) =>
  api.post(`/games/lessons/${lessonId}`, payload).then((r) => r.data)

export const updateGameScenario = (scenarioId, payload) =>
  api.put(`/games/${scenarioId}`, payload).then((r) => r.data)

export const deleteGameScenario = (scenarioId) =>
  api.delete(`/games/${scenarioId}`).then((r) => r.data)

export const uploadGameBuild = (scenarioId, file) => {
  const fd = new FormData()
  fd.append('file', file)
  return api
    .post(`/games/${scenarioId}/build`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data)
}
